import {STATUSES} from "../../components/statuses";
import axios from '@/config/axios';
import router from '@/router/index';
import each from 'lodash/each';
import dotObject from 'dot-object';
import {getField, updateField} from "vuex-map-fields";
import {GET_PROFILE, SET_STATE} from "../mutations";
import {TOGGLE_LOADER} from "@/storage/mutations";

const calculator = {
    namespaced: true,
    state: {

        amount: 200000,
        amountExternalStatus: STATUSES.APPROVE,
        amountExternalError: {
            haveError: false,
            errorText: ''
        },
        term: 9,
        termExternalStatus: STATUSES.APPROVE,
        termExternalError: {
            haveError: false,
            errorText: ''
        },
        creditType: "ANNUITY",
        creditTypeExternalStatus: STATUSES.EMPTY,
        creditTypeExternalError: {
            haveError: false,
            errorText: ''
        },
        productID: '',

        purpose: "",
        purposeExternalStatus: STATUSES.EMPTY,
        purposeExternalError: {
            haveError: false,
            errorText: ''
        },

    },
    mutations: {
        updateField
    },
    actions: {
    },
    getters: {
        getField
    }
};

export default calculator;
